import React from 'react';
import { LegalDocumentsProvider } from '../contexts/LegalDocumentsContext';
import { useLegalDocumentsData } from '../hooks/useLegalDocumentsData';
import { useManageLegalDocuments } from '../hooks/useManageLegalDocuments';

/**
 * @typedef {object} LegalDocumentsDataProviderProps
 * @property {React.ReactNode} children
 * @property {number} orgId
 */

/**
 * @param {LegalDocumentsDataProviderProps} props
 */
const LegalDocumentsDataProvider = props => {
  const { children, orgId } = props;

  const {
    legalDocuments,
    organization,
    loading: documentsLoading,
    error: documentsError,
    refetchLegalDocuments
  } = useLegalDocumentsData(orgId);

  const {
    handleAddLegalDocument,
    handleDeleteLegalDocument,
    handleDownloadLegalDocumentFile,
    addLegalDocumentError,
    deleteLegalDocumentError
  } = useManageLegalDocuments(orgId, refetchLegalDocuments);

  const value = {
    legalDocuments,
    organization,
    loading: documentsLoading,
    error: documentsError || addLegalDocumentError || deleteLegalDocumentError,
    addLegalDocument: handleAddLegalDocument,
    deleteLegalDocument: handleDeleteLegalDocument,
    downloadFile: handleDownloadLegalDocumentFile
  };

  return <LegalDocumentsProvider value={value}>{children}</LegalDocumentsProvider>;
};

export default LegalDocumentsDataProvider;
